import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Clock } from "lucide-react";
import { useSettings } from "../lib/settings";
import { InstagramLogo, WhatsAppLogo } from "./BrandIcons";

export function Footer() {
  const CONTACT = useSettings();
  return (
    <footer
      data-testid="site-footer"
      className="bg-[#1C1C1C] text-[#FAFBF6]/70 py-16 px-6"
    >
      <div className="max-w-7xl mx-auto lg:px-8 grid grid-cols-1 md:grid-cols-3 gap-12">
        <div>
          <img
            src="/assets/logo-horizontal-light.svg"
            alt="VIA PRIME Luxury"
            className="h-11 w-auto"
          />
          <p className="text-sm text-[#FAFBF6]/50 mt-5 leading-relaxed max-w-xs">
            İstanbul merkezli premium araç kiralama. Kurumsal ve uzun dönem lüks
            sedan filosu.
          </p>
        </div>

        <div className="text-xs uppercase tracking-[0.2em]">
          <div className="text-[#B09060] font-semibold mb-5">Sayfalar</div>
          <div className="flex flex-col gap-3 text-[#FAFBF6]/60">
            <Link to="/filo" className="hover:text-[#FAFBF6] transition-colors" data-testid="footer-link-filo">Filo</Link>
            <Link to="/kurumsal" className="hover:text-[#FAFBF6] transition-colors" data-testid="footer-link-kurumsal">Kurumsal Çözümler</Link>
            <Link to="/blog" className="hover:text-[#FAFBF6] transition-colors" data-testid="footer-link-blog">Blog</Link>
            <Link to="/iletisim" className="hover:text-[#FAFBF6] transition-colors" data-testid="footer-link-iletisim">İletişim</Link>
          </div>
        </div>

        <div className="text-sm text-[#FAFBF6]/60 space-y-3.5">
          <div className="text-[#B09060] text-xs uppercase tracking-[0.2em] font-semibold mb-5">İletişim</div>
          <div className="flex items-start gap-2.5">
            <MapPin className="w-4 h-4 mt-0.5 text-[#B09060] shrink-0" strokeWidth={1.25} />
            <span>{CONTACT.address}</span>
          </div>
          <div className="flex items-center gap-2.5">
            <Phone className="w-4 h-4 text-[#B09060] shrink-0" strokeWidth={1.25} />
            <a href={`tel:${CONTACT.phone.replace(/\s/g, "")}`} className="hover:text-[#FAFBF6] transition-colors" data-testid="footer-phone">
              {CONTACT.phone}
            </a>
          </div>
          <div className="flex items-center gap-2.5">
            <Mail className="w-4 h-4 text-[#B09060] shrink-0" strokeWidth={1.25} />
            <a href={`mailto:${CONTACT.email}`} className="hover:text-[#FAFBF6] transition-colors" data-testid="footer-email">
              {CONTACT.email}
            </a>
          </div>
          <div className="flex items-center gap-2.5">
            <Clock className="w-4 h-4 text-[#B09060] shrink-0" strokeWidth={1.25} />
            <span>{CONTACT.hours}</span>
          </div>
          <div className="flex items-center gap-3 pt-2">
            {CONTACT.instagram && (
              <a href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" aria-label="Instagram"
                className="block hover:scale-110 transition-transform" data-testid="footer-instagram">
                <InstagramLogo className="w-9 h-9" />
              </a>
            )}
            {CONTACT.whatsapp && (
              <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" aria-label="WhatsApp"
                className="block hover:scale-110 transition-transform" data-testid="footer-whatsapp">
                <WhatsAppLogo className="w-9 h-9" />
              </a>
            )}
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto lg:px-8 mt-12 pt-7 border-t border-[#FAFBF6]/10 flex flex-col md:flex-row items-center justify-between gap-3 text-[11px] text-[#FAFBF6]/40 tracking-wider">
        <div>Sıfır Bakım Riski • Vergi Avantajı • 7/24 Destek</div>
        <div>© {new Date().getFullYear()} VIA PRIME LUXURY</div>
      </div>
    </footer>
  );
}
